import { type Components } from '@mui/material';
import { HorizonTheme } from './horizon-theme';

export const muiDialogContent: Components<HorizonTheme>['MuiDialogContent'] = {
  defaultProps: {
    dividers: true,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      fontSize: 14,
      fontFamily: 'inherit',
      color: theme.palette.black.main,
    }),
  },
};
